<template>
  <div>
    <ExpeditingFeesPlanContenzioso/>
<!--    <el-tabs v-model="activeName">-->
<!--      <el-tab-pane name="ExpeditingFeesPlanContenzioso" label="年度计划">-->
<!--        <ExpeditingFeesPlanContenzioso v-if="activeName==='ExpeditingFeesPlanContenzioso'"/>-->
<!--      </el-tab-pane>-->
<!--      <el-tab-pane name="ExpeditingFeesPlanContenziosoEditor" label="年度计划编辑">-->
<!--        <ExpeditingFeesPlanContenziosoEditor v-if="activeName==='ExpeditingFeesPlanContenziosoEditor'"/>-->
<!--      </el-tab-pane>-->
<!--    </el-tabs>-->
  </div>
</template>

<script>
import ButlerHttp from "../../common/ButlerHttp";
import {CommonHelp} from "../../common/CommonHelp";
import ExpeditingFeesPlanContenzioso from "./ExpeditingFeesPlanContenzioso";
import ExpeditingFeesPlanContenziosoEditor from "./ExpeditingFeesPlanContenziosoEditor";
export default {
  name: "ExpeditingFeesPlanContenziosoLayout",
  inject:['where','reginWhere'],
  components: {
    ExpeditingFeesPlanContenziosoEditor,
    ExpeditingFeesPlanContenzioso},
  data() {
    return {
      activeName: "ExpeditingFeesPlanContenzioso",
      legal_house_obj: {
        total: 0,
        total2: 0,
        count: 0,
        count2: 0,
      },
    };
  },
  mounted() {
    this.handleAdd();
  },
  methods: {
    handleAdd(){
      const that = this;
      let where = {
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id
      }
      ButlerHttp.post("HouseUrgeTempLog/getLegalHouseCount",where,res=>{
        console.log(res.data)
        that.legal_house_obj = res.data;
      })
    }
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.handleAdd();
      },500,that);
    },
    "reginWhere.project_region":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.handleAdd();
      },500,that);
    },
    "reginWhere.project_name":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.handleAdd();
      },500,that);
    },
    "reginWhere.area_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.handleAdd();
      },500,that);
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/plan/ExpeditingFeesPlanContenziosoLayout.vue